<template>
  <div
    style="
      width: 100%;
      height: calc(100vh - 96px);
      overflow: hidden;
      padding-bottom: 15px;
      box-sizing: border-box;
    "
  >
    <div v-if="!isMore" class="flex margin-top-15" style="width: 100%; height: calc(100% - 15px)">
      <div
        class="help position-relative margin-x-15 color-bg-fff flex-1"
        style="box-shadow: 0px 0px 22px 1px rgba(0, 0, 0, 0.08); height: 100%"
      >
        <img
          style="
            width: 100%;
            height: 105px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
          "
          src="./static/icon_home.jpg"
        />
        <div class="search-box position-absolute">
          <div>
            <div class="font-light font-18 color-333 margin-left-40 margin-bottom-10"
              >在这里，我们为你提供帮助和支持</div
            >
            <div class="search color-bg-fff flex-center" @click="search">
              <div class="font-12 color-999 padding-x-10 margin-left-20 flex-1"
                >请输入关键词进行搜索，如班次、订单、订票等</div
              >
              <div class="search-btn flex-center" @click="search">
                <img style="width: 24px; height: 24px" src="./static/icon_home_search.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="flex" style="width: 100%; height: calc(100% - 120px)">
          <div style="width: 16%" class="padding-top-20">
            <el-menu
              class="jumpMenu"
              :default-active="activeStep"
              active-text-color="#22C655"
              @select="handleSelect"
              style="height: 100%; overflow-y: auto"
            >
              <el-menu-item v-for="(item, index) in typeList" :key="item.id" :index="index">
                <template>
                  <img style="width: 30px; height: 30px" :src="item.icon" />
                  <span slot="title" class="font-16 margin-left-5">{{ item.name }}</span>
                </template>
              </el-menu-item>
            </el-menu>
          </div>
          <div
            id="scroll_cls"
            class="flex-1 flex-col margin-top-20 padding-left-10 margin-left-20 scroll_cls"
            @scroll="onScroll"
            style="height: 99%; overflow-y: auto; border-bottom-right-radius: 10px"
          >
            <div v-for="item in articleList" :key="item.id">
              <div class="flex-start">
                <div class="title-before" v-if="item.name"></div>
                <div class="name-box margin-y-10 scroll-item">{{ item.name }}</div>
              </div>
              <div
                class="flex margin-left-10"
                style="width: calc(100% - 10px); overflow-y: auto"
                v-if="item.name"
              >
                <div
                  @click="tagClick(item, tag)"
                  v-for="tag in item.tagList"
                  :key="tag.id"
                  :class="tag.active ? 'tag-active' : 'tag'"
                  class="padding-x-20 padding-y-5 font-14 margin-right-10"
                >
                  {{ tag.name }}
                </div>
              </div>
              <div class="flex flex-wrap" style="width: 100%" v-if="item.name">
                <div
                  v-for="article in item.articleList"
                  :key="article.id"
                  @click="goDetail(article.id, article.isHot)"
                  class="article padding-10 margin-y-10 flex flex-col flex-justify-between"
                >
                  <div class="flex-between">
                    <div class="color-333 font-16 text-eli" style="max-width: 78%; font-weight: 600"
                      >{{ article.title }}
                    </div>
                    <div class="flex-center">
                      <div
                        v-if="article.isHot"
                        class="isHat color-fff flex-center font-12 margin-right-5"
                        >热</div
                      >
                      <div v-if="article.isHot" class="color-999 font-12">{{
                        article.pageView
                      }}</div>
                    </div>
                  </div>
                  <div v-html="article.content" class="color-666 font-14 content"></div>
                  <div>
                    <div
                      style="border-bottom: 1px solid #f1f1f1; width: 100%"
                      class="margin-y-5"
                    ></div>
                    <div class="flex-between">
                      <el-button
                        type="text"
                        class="font-14 font-normal padding-y-3"
                        style="color: #22c655"
                        >查看详情</el-button
                      >
                      <i class="el-icon-arrow-right font-10 color-666"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="item.name && item.pages !== item.current && item.articleList.length > 0"
                class="flex-center"
              >
                <i
                  class="el-icon-arrow-down color-999 font-light"
                  style="font-size: 24px"
                  @click="getMore(item)"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-card">
        <el-card
          shadow="always"
          style="
            height: calc(100vh - 125px);
            overflow-y: auto;
            border-radius: 10px;
            margin-right: 15px;
          "
        >
          <div slot="header" class="clearfix flex-between">
            <div class="font-20 font-weight flex-start">
              <span style="color: #22c655">公</span>
              <span class="margin-right-5">告</span>
              <img
                style="width: 6.45px; height: 16.87px"
                src="./static/icon_home_announcement.png"
              />
            </div>
            <el-button
              style="float: right; color: #22c655"
              class="font-normal padding-y-3 font-14"
              type="text"
              @click="isMore = true"
              >更多 <i class="el-icon-arrow-right font-12"></i
            ></el-button>
          </div>
          <div
            v-for="item in announcementList"
            :key="item.id"
            class="text-item flex-between margin-y-10"
            @click="getAnnouncementDetail(item.id)"
          >
            <span class="flex-start flex-1" style="width: 60%">
              <span v-if="item.isTop" class="top-title padding-x-5 margin-right-10 font-14"
                >置顶</span
              >
              <span class="text-eli title font-14 flex-1">{{ item.title }}</span>
            </span>
            <span class="color-999 font-12">{{
              item.publishTime ? dayjsFormat(item.publishTime).format('YYYY-MM-DD') : ''
            }}</span>
          </div>
        </el-card>
      </div>
    </div>
    <div
      class="padding-20 color-bg-fff margin-x-10 full-y"
      style="box-sizing: border-box; width: 100%; overflow: auto"
      v-else
    >
      <div class="padding-10 font-18">
        <el-button
          type="text"
          icon="el-icon-d-arrow-left"
          @click="isMore = false"
          style="font-size: 18px"
          >返回</el-button
        >
        <span class="margin-left-10">最新公告</span>
      </div>
      <el-table :data="announcementList" border>
        <el-table-column prop="title" label="公告标题" width="1000">
          <template slot-scope="scope">
            <div class="text-item" @click="getAnnouncementDetail(scope.row.id)">
              <span class="flex-start flex-1" style="width: 70%">
                <span v-if="scope.row.isTop" class="top-title padding-x-5 margin-right-10 font-14"
                  >置顶</span
                >
                <span class="text-eli title font-14">{{ scope.row.title }}</span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="isRead" label="状态" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.isRead ? '' : 'red-text'">{{
              scope.row.isRead ? '已查看' : '待查看'
            }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex; justify-content: right; margin-right: 20px; margin-top: 20px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="announcementPagination.current"
          :page-sizes="[15, 20, 50, 100]"
          :page-size="announcementPagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>
    <announcement-dialog ref="announcementDialog" @close="handleClose" />
    <LicenseExpireWarning ref="licenseEcpireWarning" @close="handleClose" />
  </div>
</template>

<script>
  import {
    announcementUserPage,
    popupList,
    helpLabelAll,
    typeArticlePage,
    textTypeLabel
  } from '@/api'
  import dayjs from 'dayjs'
  import announcementDialog from '@/components/announcement-dialog/announcement-dialog'
  import { isEmpty, debounce } from 'lodash-es'
  import LicenseExpireWarning from '@/components/license-expire-warning'

  export default {
    components: {
      announcementDialog,
      LicenseExpireWarning
    },
    data() {
      return {
        activeStep: '0',
        announcementList: [],
        announcementPagination: {
          current: 1,
          size: 15
        },
        total: 0,
        detailVisible: false,
        info: {},
        isMore: false,
        typeList: [],
        tagList: [],
        articleList: [],
        searchKey: '',
        isFocus: false,
        modalList: [],
        typeEnum: [
          { label: 'announcementDialog', value: 0 },
          { label: 'licenseEcpireWarning', value: 1 }
        ]
      }
    },
    created() {
      this.announcementPagination.size = 20
      this.getAnnouncementUserPage()
      this.getPopupList()
      this.getHelpLabelAll()
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('scroll', this.onScroll, true)
        this.checkScrollToBottom()
      })
    },
    methods: {
      onFocus() {
        this.isFocus = true
      },
      onBlur() {
        this.isFocus = false
      },
      search() {
        this.$router.push({
          path: '/articleSearch'
        })
      },
      async getHelpLabelAll() {
        const { code, data } = await helpLabelAll()
        if (code === 0 && !isEmpty(data)) {
          this.typeList = data.filter((item) => item.type === 1)
          // this.tagList = data.filter(item => item.type === 2)
          this.typeList.forEach((item) => {
            const obj = {}
            obj.textTypeId = item.id
            obj.tagList = [
              {
                id: '0',
                name: '全部',
                active: true
              }
            ]
            obj.current = 1
            obj.pages = 0
            obj.name = ''
            obj.articleList = []
            this.articleList.push(obj)
          })
          const params = {
            textTypeId: this.typeList[0].id,
            current: 1,
            size: 20
          }
          this.getTypeArticlePage(params, this.typeList[0].name)
          this.getTextTypeLabel(this.typeList[0].id)
        }
      },
      initPage: debounce(function (obj) {
        const params = {
          textTypeId: obj.textTypeId,
          current: obj.current,
          size: obj.size,
          labelId: obj.labelId
        }
        this.getTypeArticlePage(params, obj.name)
        this.getTextTypeLabel(obj.textTypeId)
      }, 500),
      getMore(item) {
        const tag = item.tagList.find((obj) => obj.active)
        const params = {
          textTypeId: item.textTypeId,
          current: item.current + 1,
          size: 20,
          labelId: tag.id === '0' ? '' : tag.id
        }
        this.getTypeArticlePage(params, item.name)
      },
      async getTextTypeLabel(id) {
        const { code, data } = await textTypeLabel(id)
        if (code === 0) {
          this.articleList.forEach((item) => {
            if (item.textTypeId === id) {
              item.tagList.push(...data)
            }
          })
        }
      },
      async getTypeArticlePage(params, name) {
        const { code, data } = await typeArticlePage(params)
        if (code === 0) {
          const { current, pages, records } = data
          let currentIndex = 0
          this.articleList.forEach((item, index) => {
            if (item.textTypeId === params.textTypeId) {
              currentIndex = index
              item.current = current
              item.pages = pages
              item.articleList.push(...records)
              item.name = name
            }
            if (item.articleList && Array.isArray(item.articleList) && item.articleList.length) {
              item.articleList.forEach((it) => {
                it.content = it.content.replace(/<img.*?>/g, '')
              })
            }
          })
          this.$nextTick(() => {
            this.checkHeight(currentIndex)
          })
        }
      },
      tagClick(item, tag) {
        item.tagList.forEach((obj) => {
          if (obj.active) {
            obj.active = false
          }
        })
        tag.active = !tag.active
        let labelId = tag.id
        if (tag.id === '0') {
          labelId = ''
        }
        const params = {
          textTypeId: item.textTypeId,
          current: 1,
          size: 20,
          labelId
        }
        item.articleList = []
        this.getTypeArticlePage(params, item.name)
      },
      goDetail(id, isHot) {
        this.$router.push({
          path: `/articleDetail/ad/${id}/${isHot}`
        })
      },
      getAnnouncementUserPage() {
        announcementUserPage(this.announcementPagination).then((res) => {
          const { code, data } = res
          if (code === 0) {
            this.announcementList = data.records
            this.total = data.total
          }
        })
      },
      getAnnouncementDetail(id) {
        this.$refs.announcementDialog.init(id)
      },
      handleSizeChange(e) {
        this.announcementPagination.size = e
        this.getAnnouncementUserPage()
      },
      handleCurrentChange(e) {
        this.announcementPagination.current = e
        this.getAnnouncementUserPage()
      },
      dayjsFormat(val) {
        return dayjs(val)
      },
      getPopupList() {
        popupList().then((res) => {
          const { code, data } = res
          if (code) return
          if (!data || !Array.isArray(data) || !data.length) return
          this.modalList = data
          const [obj] = data
          if (!obj.type) {
            this.$refs.announcementDialog.init(obj.link)
            return
          }
          const result = {link: obj.link, time: obj.exData.updateTime}
          this.$refs.licenseEcpireWarning.init(result)
        })
      },
      handleClose() {
        this.modalList.shift()
        if (!this.modalList.length) return
        const [obj = {}] = this.modalList
        const refValue = this.typeEnum.find((it) => it.value === obj.type).label
        if (!refValue) return
        this.$refs[refValue].init(obj.link)
      },
      checkHeight(index) {
        const element = document.getElementById('scroll_cls')
        if (element.scrollHeight > element.clientHeight) {
          // 溢出产生了滚动条
        } else {
          const params = {
            textTypeId: this.typeList[index + 1].id,
            current: 1,
            size: 20
          }
          this.getTypeArticlePage(params, this.typeList[index + 1].name)
          this.getTextTypeLabel(this.typeList[index + 1].id)
        }
      },
      onScroll(e) {
        const scrollItems = document.querySelectorAll('.scroll-item')
        for (let i = scrollItems.length - 1; i >= 0; i--) {
          // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
          const judge = e.target.scrollTop >= scrollItems[i].offsetTop - scrollItems[0].offsetTop
          if (judge) {
            this.activeStep = i.toString()
            break
          }
        }
      },
      checkScrollToBottom() {
        const scrollThreshold = 20 // 设置滚动阈值，单位为像素
        const element = document.getElementById('scroll_cls')
        const _this = this
        element.addEventListener('scroll', function () {
          const distanceFromBottom = element.scrollHeight - element.scrollTop - element.clientHeight
          if (distanceFromBottom < scrollThreshold) {
            const index = _this.findLastHotIndex(_this.articleList)
            if (index !== -1 && index !== _this.articleList.length - 1) {
              const params = {
                textTypeId: _this.typeList[index + 1].id,
                current: 1,
                size: 20,
                name: _this.typeList[index + 1].name
              }
              _this.initPage(params)
            }
          }
        })
      },
      findLastHotIndex(arr) {
        for (let i = arr.length - 1; i >= 0; i--) {
          if (arr[i].name) {
            return i
          }
        }
        return -1 // 如果找不到任何一个isHot为true的对象，返回-1
      },
      async handleSelect(index) {
        if (!this.articleList[index].name) {
          const params = {
            textTypeId: this.typeList[index].id,
            current: 1,
            size: 20
          }
          await this.getTypeArticlePage(params, this.typeList[index].name)
          await this.getTextTypeLabel(this.typeList[index].id)
          this.onAnchor(index)
          return
        }
        this.onAnchor(index)
      },
      onAnchor(index) {
        const target = document.querySelector('.scroll_cls')
        const scrollItems = document.querySelectorAll('.scroll-item')
        // 判断滚动条是否滚动到底部
        if (target.scrollHeight <= target.scrollTop + target.clientHeight) {
          this.activeStep = index
        }
        const total = scrollItems[index].offsetTop - scrollItems[0].offsetTop // 锚点元素距离其offsetParent(这里是body)顶部的距离(待滚动的距离)
        let distance = document.querySelector('.scroll_cls').scrollTop // 滚动条距离滚动区域顶部的距离
        let step = total / 50
        if (total > distance) {
          smoothDown(document.querySelector('.scroll_cls'))
        } else {
          const newTotal = distance - total
          step = newTotal / 50
          smoothUp(document.querySelector('.scroll_cls'))
        }
        // 参数element为滚动区域
        function smoothDown(element) {
          if (distance < total) {
            distance += step
            element.scrollTop = distance
            setTimeout(smoothDown.bind(this, element), 10)
          } else {
            element.scrollTop = total
          }
        }
        // 参数element为滚动区域
        function smoothUp(element) {
          if (distance > total) {
            distance -= step
            element.scrollTop = distance
            setTimeout(smoothUp.bind(this, element), 10)
          } else {
            element.scrollTop = total
          }
        }
        document.querySelectorAll('.scroll-item').forEach((item, index1) => {
          if (index === index1) {
            item.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            })
          }
        })
      }
    }
  }
</script>

<style scoped="scoped" lang="scss">
  .help {
    border-radius: 10px;
  }

  .search-box {
    top: 15px;
    left: 8%;

    .search {
      cursor: pointer;
      transition: all 0.3s linear;
      width: 120%;
      height: 36px;
      border-radius: 42px;
      box-shadow: 0px 0px 22px 1px rgba(0, 0, 0, 0.1);

      .search-btn {
        height: 100%;
        width: 20%;
        background-color: #22c655;
        border-radius: 0px 42px 42px 0px;
        box-shadow: 0px 0px 22px 1px rgba(0, 0, 0, 0.05);
      }
    }
  }

  .serachInput_active {
    transition: all 0.3s linear;
    transform: scale(1.05, 1.05);
    box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.5);
  }

  .tag {
    cursor: pointer;
    background: #f6f6f6;
    border-radius: 6px;
    color: #999999;

    &-active {
      border-radius: 6px;
      background: #e2f7e5;
      color: #22c655;
    }
  }

  .isHat {
    width: 18px;
    height: 18px;
    background: linear-gradient(180deg, #ff9993, #ec564d 100%);
    border-radius: 4px;
  }

  .content {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 行数 */
    -webkit-box-orient: vertical;
  }

  .name-box {
    font-size: 18px;
    font-weight: 500;
    margin-left: 10px;
  }

  .title-before {
    background-color: #22c655;
    width: 3px;
    height: 18px;
    border-radius: 1px;
  }

  .article {
    width: 20%;
    margin-right: 15px;
    border-radius: 4px;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.06);
  }

  ::v-deep .el-input__inner {
    border: none !important;
    box-shadow: none !important;
    padding: 0px; //前边边距去掉
  }

  .container-box {
    height: 100%;
  }

  .box-card {
    width: 22%;
  }

  .text-item {
    width: 100%;
    cursor: pointer;
  }

  .top-title {
    border: 1px solid #f9483d;
    border-radius: 4px;
    color: #f9483d;
  }

  .title {
    width: 72%;
  }

  .red-title {
    border: 1px solid #f9483d;
    border-radius: 4px;
    color: #f9483d;
    padding: 0;
  }

  .red-text {
    color: #f9483d;
  }

  .normal-title {
    color: #000;
    font-weight: 400;
    padding: 0;
  }

  .el-card.is-always-shadow {
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  }
  ::v-deep {
    .el-menu-item.is-active {
      background: #e2f7e5;
    }
    .el-menu-item:hover {
      background: #e2f7e5;
    }
  }
</style>
